/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import AddAppointment from './AddAppointment/index'
import NewNote from './NewNote/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/TimelineEvent/FutureSeparator/Actions"
  
}) {
  return (<React.Fragment
>
<NewNote
  viewPath={`${viewPath}/NewNote`}
/>
<AddAppointment
  viewPath={`${viewPath}/AddAppointment`}
/>
{children}
</React.Fragment>)
}